import React, { createContext } from "react";
import { useSocket } from "../hooks/useSocket";



export const SocketContext = createContext();


export const SocketProvider = ({ children }) => {

    const server_url=  process.env.REACT_APP_PRODUCCION;  
    // 'http://178.128.152.77:8080?entidad=femcc-01'
    const { socket, online } = useSocket(`${server_url}?entidad=femcc-01`);

    return (
        
        <SocketContext.Provider value={{ socket, online }} >
            { children }
        </SocketContext.Provider>
    ) 
}